const ParentEmpty = ({ msg }) => {
    return <div className="text-center text-gray-500 dark:text-gray-400 py-10 text-lg font-medium">{msg || 'لا توجد بيانات'}</div>
};

export default ParentEmpty;